import { Box, FormControlLabel } from '@mui/material';
import type { PartnerFacilitiesFilter } from '../../API/services/PartnerFacilityFilterService';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import CustomCheckbox from '@ui-components/CheckBox/CustomCheckBox';

type Props = Readonly<{
  followUpdata: PartnerFacilitiesFilter | undefined;
  value: number[];
  onChange: (value: number[]) => void;
}>;

export function FollowUpFilterSelector({
  followUpdata,
  value,
  onChange,
}: Props) {
  const handleSelection = (followUpId: number, isChecked: boolean) => {
    onChange(
      isChecked
        ? [...value, followUpId]
        : value.filter((id) => id !== followUpId)
    );
  };

  return (
    <Box>
      {followUpdata?.followUpList.map((followUp) => (
        <Box key={followUp.id}>
          <FormControlLabel
            control={
              <CustomCheckbox
                id={`follow-up-checkbox-${followUp.id}`}
                checked={value.includes(followUp.id)}
                onChange={(event) =>
                  handleSelection(followUp.id, event.target.checked)
                }
              />
            }
            label={
              <CustomTypography
                id={`follow-up-label-${followUp.id}`}
                variant="body2"
              >
                {followUp.name}
              </CustomTypography>
            }
          />
        </Box>
      ))}
    </Box>
  );
}
